import PropTypes from 'prop-types';
import React from 'react';

import { Trans, useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';

const Introduction = ({ showLoginText, text, handleLogin }) => {
  const { t } = useTranslation('core');

  return (
    <p>
      {text}
      {showLoginText && (
        <Trans
          i18nKey="quickstarts.introduction.recommendationText"
          components={[<span key="0" />, <a key="1" className={styles.logInButton} onClick={handleLogin} />]}
        >
          {' '}
          {'We recommend that you <1>log in</1> to follow this quickstart with examples configured for your account.'}
        </Trans>
      )}
    </p>
  );
};

Introduction.propTypes = {
  showLoginText: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  handleLogin: PropTypes.func.isRequired,
};

export default Introduction;
